import { Copy, Heart } from 'lucide-react';

import type { CheckInQuestion } from '../data/check-in-questions';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { toast } from '@/components/ui/use-toast';
import { cn } from '@/lib/utils';
import { useFavoritesStore } from '@/stores/favorites-store';

interface QuestionCardProps {
  question: CheckInQuestion;
}

export function QuestionCard({ question }: QuestionCardProps) {
  const { toggle, isFavorite } = useFavoritesStore();
  const favorited = isFavorite(question.id);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(question.question);
    toast({ title: 'Copied to clipboard' });
  };

  return (
    <Card>
      <CardContent className="flex items-start gap-4 p-4">
        <div className="flex-1 space-y-1">
          <p className="font-medium">"{question.question}"</p>
          <p className="text-sm text-muted-foreground">{question.contextNote}</p>
        </div>
        <div className="flex shrink-0 gap-1">
          <Button variant="ghost" size="icon" onClick={handleCopy} title="Copy to clipboard">
            <Copy className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => toggle(question.id)}
            title={favorited ? 'Remove from favorites' : 'Add to favorites'}
          >
            <Heart className={cn('h-4 w-4', favorited && 'fill-current text-red-500')} />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
